module.exports = __webpack_public_path__ + "static/media/massage-banner-mobile.2d38d592.svg";